import appConfig from 'config';

const SERVER_URL = appConfig.api.SERVER_URL;

export interface MaintenanceStatusResponse {
  status: string;
  maintenanceMode: boolean;
  expectedEndTime: string | null;
}

/**
 * Check maintenance status from the backend.
 * Uses raw fetch (not axiosClient) to avoid interceptor loops and auth requirements.
 * 
 * @returns Promise with maintenance status
 */
export async function checkMaintenanceStatus(): Promise<MaintenanceStatusResponse> {
  try {
    const response = await fetch(`${SERVER_URL}/maintenance/status`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      // Don't cache maintenance status
      cache: 'no-store',
    });

    if (!response.ok) {
      // If the endpoint returns non-2xx, fail-open for initial checks
      // Return status 'ERROR' so callers can distinguish from actual responses
      return {
        status: 'ERROR',
        maintenanceMode: false,
        expectedEndTime: null,
      };
    }

    const data = await response.json();
    return {
      status: data.status || 'OK',
      maintenanceMode: data.maintenanceMode === true,
      expectedEndTime: data.expectedEndTime || null,
    };
  } catch (error) {
    // On network error, fail-open (assume not in maintenance) for initial checks
    // Return status 'ERROR' so callers can distinguish from actual responses
    console.error('Failed to check maintenance status:', error);
    return {
      status: 'ERROR',
      maintenanceMode: false,
      expectedEndTime: null,
    };
  }
}

